import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button from '@mui/material/Button';
import { useCallback, useEffect } from 'react';
import { createFriendsListClosedOutbound, createFriendsListOpenOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { clearActiveContacts } from '../../redux/actions/contactsActions';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
import { PANEL_FRAMELESS_CONTENT_PADDING_STRING } from '../../styles/styles';
import { PanelHeader } from '../panelHeader';
import { PanelContainer } from '../panelStyles';
import { FriendsPanelContentsContainer } from './friendsPanelContentsContainer';
export const FriendsPanel = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickAddFriend = useCallback(() => {
        dispatch(addMessageBox({ type: 'add-friend' }));
    }, [dispatch]);
    useEffect(() => {
        socketSend(createFriendsListOpenOutbound());
        return () => {
            dispatch(clearActiveContacts());
            socketSend(createFriendsListClosedOutbound());
        };
    }, [dispatch, socketSend]);
    return (_jsxs(PanelContainer, { padding: PANEL_FRAMELESS_CONTENT_PADDING_STRING, "aria-label": 'friends panel', children: [_jsx(PanelHeader, { title: 'Friends', withPadding: true, headerRight: _jsx(Button, { variant: 'contained', size: 'small', onClick: onClickAddFriend, startIcon: _jsx(AddCircleOutlineIcon, {}), children: "Add" }) }), _jsx(FriendsPanelContentsContainer, {})] }));
};
